import React, { useContext, useRef, useEffect } from 'react'
import * as bootstrap from 'bootstrap'

import ToastContext from '../../context/Toast'
import useEvent from '../../hooks/useEventHandler'

import './Toast.scss'

/**
 * Bootstrap 5 toast component integrated with reactjs. Watches a global 'toast' state to show/hide itself
 *
 * @component
 * @example
 * return (
 *   <Toast />
 * )
 */

const CustomToast = () => {

    const { toast, setToast } = useContext(ToastContext)
    const toastRef = useRef()

    const handleToastHidden = () => setToast('')

    // fires on mount & every subsequent re-render
    useEffect(() => {
        var bsToast = bootstrap.Toast.getInstance(toastRef.current)
        
        if (!bsToast) {
            // initialize Toast & hide after init
            bsToast = new bootstrap.Toast(toastRef.current, {autohide: false})
            bsToast.hide()
        }
        if (toast) {
            bsToast.show()
            setTimeout(() => bsToast.hide(), 5000)
        }
    })

    useEvent('hidden.bs.toast', handleToastHidden)

    return (
        <div className="toasts toast-container position-absolute bottom-0 end-0 py-2">
            <div className="toast m-4" role="alert" ref={toastRef}>
                <div className="toast-header">
                    <strong className="me-auto">ZealStream</strong>
                    <small className="text-muted">Just Now</small>
                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div className="toast-body">
                    {toast}
                </div>
            </div>
        </div>
    )

}

export default CustomToast